import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LCS_API_CONFIG, LcsApiConfig } from '@lcs/shared/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserPreferenceDetailFormValue } from 'src/app/pages/user-preferences/models/user-preference-detail-form';
import { UserPreferenceDetailSaveModel } from 'src/app/pages/user-preferences/models/user-preference-detail-save.model';
import {
   saveUserPreferenceDetail,
   saveUserPreferenceDetailFailure,
   saveUserPreferenceDetailSuccess,
} from 'src/app/pages/user-preferences/state/user-preference-detail.actions';
import * as UserPreferencesActions from './user-preferences.actions';

@Injectable()
export class UserPreferencesEffects {
   saveExpandMenu = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferencesActions.saveExpandMenu),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue = convertExpandMenuValueToEffectiveUserPreferenceSubmitValue(
               action.expandMenu
            );

            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http
               .post<EffectiveUserPreferenceSubmitValue>(url, effectiveUserPreferenceSubmitValue, {
                  observe: 'response',
               })
               .pipe(
                  map(() => {
                     return UserPreferencesActions.saveExpandMenuSuccess({
                        expandMenu: action.expandMenu,
                     });
                  }),
                  catchError(({ error }) => {
                     return of(UserPreferencesActions.saveExpandMenuFailure(error));
                  })
               );
         })
      );
   });

   saveSelectedDashboardId = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferencesActions.saveSelectedDashboardId),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue = convertSelectedDashboardIdToEffectiveUserPreferenceSubmitValue(
               action.selectedDashboardId
            );

            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http
               .post<EffectiveUserPreferenceSubmitValue>(url, effectiveUserPreferenceSubmitValue, {
                  observe: 'response',
               })
               .pipe(
                  map(() => {
                     return UserPreferencesActions.saveSelectedDashboardIdSuccess({
                        selectedDashboardId: action.selectedDashboardId,
                     });
                  }),
                  catchError(({ error }) => {
                     return of(UserPreferencesActions.saveSelectedDashboardIdFailure(error));
                  })
               );
         })
      );
   });

   saveMostRecentDeviceType = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferencesActions.saveMostRecentDeviceType),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue = convertmostRecentDeviceTypeToEffectiveUserPreferenceSubmitValue(
               action.mostRecentDeviceType
            );

            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http
               .post<EffectiveUserPreferenceSubmitValue>(url, effectiveUserPreferenceSubmitValue, {
                  observe: 'response',
               })
               .pipe(
                  map(() => {
                     return UserPreferencesActions.saveMostRecentDeviceTypeSuccess({
                        mostRecentDeviceType: action.mostRecentDeviceType,
                     });
                  }),
                  catchError(({ error }) => {
                     return of(UserPreferencesActions.saveMostRecentDeviceTypeFailure(error));
                  })
               );
         })
      );
   });

   saveShowExtensionRegisterPopup = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferencesActions.saveShowExtensionRegisterPopup),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue =
               convertshowExtensionRegisterPopupToEffectiveUserPreferenceSubmitValue(action.showExtensionRegisterPopup);

            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http
               .post<EffectiveUserPreferenceSubmitValue>(url, effectiveUserPreferenceSubmitValue, {
                  observe: 'response',
               })
               .pipe(
                  map(() => {
                     return UserPreferencesActions.saveShowExtensionRegisterPopupSuccess({
                        showExtensionRegisterPopup: action.showExtensionRegisterPopup,
                     });
                  }),
                  catchError(({ error }) => {
                     return of(UserPreferencesActions.saveShowExtensionRegisterPopupFailure(error));
                  })
               );
         })
      );
   });

   saveQueueHistoryRegisterWrapQueues = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferencesActions.saveQueueHistoryRegisterWrapQueues),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue =
               convertQueueHistoryRegisterWrapQueuesToEffectiveUserPreferenceSubmitValue(
                  action.queueHistoryRegisterWrapQueues
               );

            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http
               .post<EffectiveUserPreferenceSubmitValue>(url, effectiveUserPreferenceSubmitValue, {
                  observe: 'response',
               })
               .pipe(
                  map(() => {
                     return UserPreferencesActions.saveQueueHistoryRegisterWrapQueuesSuccess({
                        queueHistoryRegisterWrapQueues: action.queueHistoryRegisterWrapQueues,
                     });
                  }),
                  catchError(({ error }) => {
                     return of(UserPreferencesActions.saveQueueHistoryRegisterWrapQueuesFailure(error));
                  })
               );
         })
      );
   });

   saveExpandCallDetailAdvancedSection = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferencesActions.saveExpandCallDetailAdvancedSection),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue =
               convertExpandCallDetailAdvancedSectionToEffectiveUserPreferenceSubmitValue(
                  action.expandCallDetailAdvancedSection
               );

            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http
               .post<EffectiveUserPreferenceSubmitValue>(url, effectiveUserPreferenceSubmitValue, {
                  observe: 'response',
               })
               .pipe(
                  map(() => {
                     return UserPreferencesActions.saveExpandCallDetailAdvancedSectionSuccess({
                        expandCallDetailAdvancedSection: action.expandCallDetailAdvancedSection,
                     });
                  }),
                  catchError(({ error }) => {
                     return of(UserPreferencesActions.saveExpandCallDetailAdvancedSectionFailure(error));
                  })
               );
         })
      );
   });

   saveUserPreferences = createEffect(() => {
      return this.actions$.pipe(
         ofType(saveUserPreferenceDetail),
         switchMap((action) => {
            const effectiveUserPreferenceSubmitValue =
               convertUserPreferenceDetailSubmitValueToEffectiveUserPreferenceSubmitValue(
                  action.userPreference,
                  action.userPreferenceFields
               );
            const url = `${
               this.currentEffectiveUserPreferenceUrl
            }?fields=${effectiveUserPreferenceSubmitValue.fields.join(',')}`;
            return this.http.post<UserPreferenceDetailFormValue>(url, effectiveUserPreferenceSubmitValue).pipe(
               map((r) => {
                  return saveUserPreferenceDetailSuccess({
                     effectiveUserPreferences: { ...action.userPreference, ...r },
                     userPreferenceSubmitValue: action.userPreference,
                  });
               }),
               catchError(({ error }) => {
                  return of(saveUserPreferenceDetailFailure(error));
               })
            );
         })
      );
   });

   private currentEffectiveUserPreferenceUrl: string;

   constructor(private actions$: Actions, @Inject(LCS_API_CONFIG) apiConfig: LcsApiConfig, private http: HttpClient) {
      if (!apiConfig || !apiConfig.baseUrl) {
         throw new Error("Invalid API configuration. 'baseUrl' is required.");
      }
      this.currentEffectiveUserPreferenceUrl = `${apiConfig.baseUrl}/Current/EffectiveUserPreference`;
   }
}

export function convertExpandMenuValueToEffectiveUserPreferenceSubmitValue(
   expandMenu: boolean
): EffectiveUserPreferenceSubmitValue {
   return {
      expandMenu: expandMenu,
      fields: ['ExpandMenu'],
   };
}

export function convertSelectedDashboardIdToEffectiveUserPreferenceSubmitValue(
   selectedDashboardId: number | null
): EffectiveUserPreferenceSubmitValue {
   return {
      selectedDashboardId: selectedDashboardId,
      fields: ['SelectedDashboardId'],
   };
}

export function convertmostRecentDeviceTypeToEffectiveUserPreferenceSubmitValue(
   mostRecentDeviceType: string | null
): EffectiveUserPreferenceSubmitValue {
   return {
      mostRecentDeviceType: mostRecentDeviceType,
      fields: ['MostRecentDeviceType'],
   };
}

export function convertshowExtensionRegisterPopupToEffectiveUserPreferenceSubmitValue(
   showExtensionRegisterPopup: boolean | null
): EffectiveUserPreferenceSubmitValue {
   return {
      showExtensionRegisterPopup: showExtensionRegisterPopup,
      fields: ['ShowExtensionRegisterPopup'],
   };
}

export function convertQueueHistoryRegisterWrapQueuesToEffectiveUserPreferenceSubmitValue(
   queueHistoryRegisterWrapQueues: boolean | null
): EffectiveUserPreferenceSubmitValue {
   return {
      queueHistoryRegisterWrapQueues: queueHistoryRegisterWrapQueues,
      fields: ['QueueHistoryRegisterWrapQueues'],
   };
}

export function convertExpandCallDetailAdvancedSectionToEffectiveUserPreferenceSubmitValue(
   expandCallDetailAdvancedSection: boolean | null
): EffectiveUserPreferenceSubmitValue {
   return {
      expandCallDetailAdvancedSection: expandCallDetailAdvancedSection,
      fields: ['ExpandCallDetailAdvancedSection'],
   };
}

export function convertUserPreferenceDetailSubmitValueToEffectiveUserPreferenceSubmitValue(
   userPreference: UserPreferenceDetailSaveModel,
   fields: any[]
): EffectiveUserPreferenceSubmitValue {
   return {
      useAlternatingRowColors: userPreference.useAlternatingRowColors,
      fields: fields,
   };
}

export interface EffectiveUserPreferenceSubmitValue {
   expandMenu?: boolean | null;
   selectedDashboardId?: number | null;
   mostRecentDeviceType?: string | null;
   showExtensionRegisterPopup?: boolean | null;
   useAlternatingRowColors?: boolean | null;
   queueHistoryRegisterWrapQueues?: boolean | null;
   expandCallDetailAdvancedSection?: boolean | null;
   fields: string[];
}
